import React from "react";

/**
 * Royal Wow Meals brand logo.
 * `variant`: "full" shows the gold tile; "mark" shows just the image trimmed to a square.
 */
export default function Logo({ className = "", variant = "mark", ...rest }) {
  const base =
    variant === "full"
      ? "rounded-2xl overflow-hidden shadow-lg shadow-black/20"
      : "rounded-full overflow-hidden ring-1 ring-black/10";
  return (
    <div className={`${base} ${className}`} {...rest}>
      <img
        src="/royal-wow-logo.jpg"
        alt="Royal Wow Meals"
        className="w-full h-full object-cover"
      />
    </div>
  );
}
